import React from "react";

import { ProductImageRenditions } from "@utils/enums";

import { ConfigurableProductRenditions } from "@components/Product/ProductImage/mappedRenditions";
import { ProductImageContainer } from "@components/Product/ProductImage/productImage.container";

interface ConfigurableProductImageComponentProps {
    title?: string;
    imageUrl?: string;
}

const ConfigurableProductImageComponent = ({
    title,
    imageUrl = "",
}: ConfigurableProductImageComponentProps) => {
    return (
        <ProductImageContainer
            title={title}
            medias={[
                {
                    url: imageUrl,
                    format: ProductImageRenditions.SM,
                    altText: title,
                },
            ]}
            renditions={ConfigurableProductRenditions}
            isEcoChequesAccepted={false}
        />
    );
};

export {
    ConfigurableProductImageComponent,
    ConfigurableProductImageComponentProps,
};
